// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".referrals-sidebar{position:fixed;height:100%;background-color:#fff;z-index:100}.accelerate .el-icon-arrow-up:before{color:#333}.mainScrollBar{height:100vh;overflow:hidden}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
